//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { wxConfig, wxScanQrCode } from "../../Interface/wx";
import myecharts from '@/util/myecharts'

export default {
    data() {
        return {
            userInfo:'',
            show_pwd:false,
            pwd:'',
            rpwd:'',
        }
    },
    mounted(){
        this.init()
    },
    methods:{
        // 初始化
        init(){
            let userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
            console.log(userInfo);
            this.userInfo = userInfo

            this.$post('/app/order/getOutputSeven').then(res => {
                let s = res.data
                let x = res.date
                myecharts.bar_chart('one',x,null,s,'生产进度')
            })

            this.$post('/app/order/distributionOfDefectiveItems').then(res => {
                console.log(res.data);

                // let newData = [
                //     {num: "5", name: "裂开1", proportion: 5},
                //     {num: "15", name: "裂开2", proportion: 15},
                //     {num: "10", name: "裂开3", proportion: 10},
                //     {num: "10", name: "裂开4", proportion: 10},
                //     {num: "40", name: "裂开5", proportion: 40},
                //     {num: "15", name: "裂开6", proportion: 15},
                //     {num: "5", name: "裂开7", proportion: 5},
                // ]
                
                let arr = res.data
                let len = arr.length;
                for(let k = 0; k < len - 1; k++) {
                    for(let m = 0; m < len - k - 1; m++) {
                        if(arr[m].proportion < arr[m+1].proportion){
                            let val = arr[m];
                            arr[m] = arr[m+1];
                            arr[m+1] = val;
                        }
                    }
                }
                let countData = []
                if(arr.length > 4){
                    let lastTotal = 0
                    for(let i=0; i < arr.length; i++){
                        if(i < 3){
                            countData.push(arr[i])
                        }else{
                            lastTotal += (arr[i].num - 0)
                        }
                    }
                    countData.push({num: lastTotal+'' , name: "其他" , proportion: 0})
                }else{
                    for(let i=0; i < arr.length; i++){
                        countData.push(arr[i])
                    }
                }
                // console.log(countData);

                let data = countData.map(item => {
                    return {value:item.num,name:item.name}
                })
                myecharts.pie_chart('不良品分布','two',data)
            })
        },
        
        // 扫码
        scanQrcode(){
            this.$post("/app/wechat/getSignInfo", {
                url: window.location.href.split("#")[0],
            }).then((res) => {
                res.jsApiList = ['scanQRCode', 'checkJsApi'];
                console.log(res);
                setTimeout(() => {
                    wxConfig(res);
                    wxScanQrCode();
                }, 200);
                
            }); 
        },
        // 修改密码
        ModifyPwd(){
            this.show_pwd = true
        },
        // 保存新密码
        SaveNewPwd(){
            let data = {
                pwd:this.pwd,
                rpwd:this.rpwd,
            }
            if(this.pwd === this.rpwd){
                this.$post('/app/user/updatePwd',data).then(res => {
                    this.$toast.success('修改成功!');
                    this.show_pwd = false
                })
            }else{
                this.$toast.fail('两次密码不相同!');
            }
        },

        // 退出登录
        onLoginOut(){
            sessionStorage.removeItem('token')
            this.$router.push({
                path:'/OrderDetails',
                query:{id:id}
            })
        },        
    }
}



// WEBPACK FOOTER //
// ./src/components/home/four.vue